export default "/fonts/RV-Harmonia-Bold.woff?dca960697b149336e0106facc221e7e3";